import { Component } from '@angular/core';

@Component({
  selector: 'app-founding-circle',
  templateUrl: './founding-circle.html',
  styleUrl: './founding-circle.scss',
})
export class FoundingCircle {}
